import {useContext} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import CenterContext from 'context/CenterContext';

let myAbilities = HelpAbility();

function Item({i, center, deleteCenter}){
 const {setCenter} = useContext(CenterContext);
 const {_id, codigoCentro, nombre, horarioAtencion, ubicacion, almacen, esCentro, recogerEnPunto} = center;
 const {direccion} = ubicacion;
 const {codLogistica} = ubicacion;
 const {codigo} = almacen;

 const handleIsUpdateForm = () => {
    setCenter({...center, ubicacion: {...center.ubicacion, codLogistica: center.ubicacion.codLogistica._id}, almacen: center.almacen._id})
 }
 
 const handleDeleteCenter = async () => {
    deleteCenter({id: _id})
 }

 return (
   <tr>
      <th className="text-center" scope="row">{i + 1}</th>
      <td className="text-center">{codigoCentro}</td>
      <td className="text-center">{nombre}</td>
      <td className="text-center">{horarioAtencion}</td>
      <td className="text-center">{direccion}</td>
      <td className="text-center">{codLogistica.codLogistica}</td>
      <td className="text-center">{codigo}</td>
      <td className="text-center">{esCentro ? "Centro" : "Agente"}</td>
      <td className="text-center">{recogerEnPunto ? "✔" : "❌"}</td>


      {myAbilities.hasAny([C.A.CENTER.UPDATE, C.A.CENTER.DELETE]) && <td className="text-center d-flex">
          {myAbilities.has(C.A.CENTER.UPDATE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={handleIsUpdateForm}>
                  <i className="bi bi-pencil-square"/>
              </button>
          </OverlayTrigger>}
          {myAbilities.has(C.A.CENTER.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-danger"
                      onClick={handleDeleteCenter}>
                  <i className="bi bi-trash"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item